<!-- 销售控销数据操作 -->
<template>
    <div>
        <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                <v-tabs :type="dataActionBox.actionType" :activeName="'新增'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0">
                                <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                        <el-form-item label="比例(0-1)" prop="rate" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <el-input @input="calculate" v-model="sendDataInfo.rate" type="number" placeholder="请输入比例"></el-input>
                                        </el-form-item>
                                        <el-form-item label="总金额" prop="totalMoney">
                                            <el-input v-model="sendDataInfo.totalMoney" readonly placeholder="总金额"></el-input>
                                        </el-form-item>
                                        <el-form-item label="退补金额" prop="tbMoney">
                                            <el-input v-model="sendDataInfo.tbMoney" readonly placeholder="退补金额"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>

                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
            <div class="foots">
                <div>
                    <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType != 2">保存</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    name: "rateSalesReimburAction",
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                rate: "",
                totalMoney: 0,
                tbMoney: 0,
                wobkemIds: [],
            },
            tabForm: [
                {
                    jciName: "新增",
                }
            ], // tab循环的主表单
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        calculate() {
            if (this.sendDataInfo.rate > 1) {
                this.sendDataInfo.rate = 0
                this.sendDataInfo.tbMoney = this.$common.getDecimalInfo(3, NP.times(Number(this.sendDataInfo.rate || 0), Number(this.sendDataInfo.totalMoney || 0)))
            } else {
                this.sendDataInfo.rate = this.$common.updataNum('rate', this.sendDataInfo).rate;
                this.sendDataInfo.tbMoney = this.$common.getDecimalInfo(3, NP.times(Number(this.sendDataInfo.rate || 0), Number(this.sendDataInfo.totalMoney || 0)))
            }
        },
        //初次进入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.sendDataInfo = {
                rate: "",
                totalMoney: this.actionData.oldData.totalMoney || 0,
                tbMoney: 0,
                wobkemIds: this.actionData.oldData.wobkemIds || [],
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getBtnHeight()
                    }
                }, 16.7)
            });
        },
        //取消
        initActionBox(sendDataInfo) {
            this.$emit("drawerCancel", 0);
            this.$refs[sendDataInfo].resetFields();
        },
        //新增和修改
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    // console.log('sendDataInfo',this.sendDataInfo)
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        //新增和修改提交
        async sub() {
            var sendData = {
                rate: this.sendDataInfo.rate,
                wobkemIds: this.sendDataInfo.wobkemIds,
            }
            var responseData = await this.$http.RrApplyaddWhole(sendData);
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", responseData.result);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeDestroy() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
 
<style scoped>
/* ::v-deep .current-row td {
    background-color: #fff7ca !important;
} */
.el-table .rowStyle {
    background: #fff7ca !important;
}

.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 2px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}

#mainInfo {
    padding-bottom: 5px !important;
}

.details {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.details .left {
    width: 35%;
    flex-shrink: 0;
}

.details .right {
    width: 64%;
    flex-shrink: 0;
}

.details .active {
    width: 100%;
    flex-shrink: 0;
}
</style>